import Link from "next/link";
import { MdKeyboardArrowRight } from "react-icons/md";
import { memo, useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { AppContext } from "@/contexts/appContexts";
import { getCategoryData } from "@/utils/category";
// import useClient from "@/hooks/global/useClient";
// import Skeleton from "../Skeleton";

function BreadCrumb() {
  const router = useRouter();
  const { categoryData } = useContext(AppContext);
  const [ArrayOfBreadCrumb, setArrayOfBreadCrumb] = useState([]);

  // const { isClient } = useClient();

  useEffect(() => {
    const parseCategoryUrls = router?.query?.catId;
    const bc = parseCategoryUrls
      ?.map((url) =>
        getCategoryData(categoryData?.children_data, "url_key", url)
      )
      ?.filter((item) => item?.id);
    setArrayOfBreadCrumb(bc);
  }, [router.query, categoryData?.children_data]);

  return (
    <div className="w-[80%] max-[570px]:w-[98%] mx-auto mt-0 mb-5 min-h-6">
      {/* {!isClient && <Skeleton className="my-5 min-h-6 w-[51px]" />} */}
      {ArrayOfBreadCrumb?.length ? (
        <div className="flex items-center p-2 bg-white rounded-md">
          <Link href="/" className="duration-200 hover:text-red">
            {router.locale === "en" ? "Home" : "الرئيسية"}
          </Link>
          <MdKeyboardArrowRight
            size="20px"
            className={`mx-2 ${
              router.locale === "en" ? "rotate-0" : "rotate-180"
            }`}
          />

          {ArrayOfBreadCrumb.map((item, i) => {
            const link = ArrayOfBreadCrumb?.slice(0, i + 1)
              .map((item) => item?.url_key)
              ?.join("/");
            return (
              <div key={i} className="flex items-center justify-center">
                {ArrayOfBreadCrumb?.length - 1 > i ? (
                  <Link
                    href={`/${link}`}
                    className="duration-200 hover:text-red"
                  >
                    {item?.name}
                  </Link>
                ) : (
                  <h1 className="duration-200 text-red">{item?.name}</h1>
                )}

                {ArrayOfBreadCrumb.length - 1 > i && (
                  <MdKeyboardArrowRight
                    size="20px"
                    className={`mx-2 ${
                      router.locale === "en" ? "rotate-0" : "rotate-180"
                    }`}
                  />
                )}
              </div>
            );
          })}

          {/*
           */}
        </div>
      ) : null}
    </div>
  );
}

export default memo(BreadCrumb);
